import withProps from '@dyl/utils/withProps';
import { createSpeakingTaskType } from '../../createTaskType';
import SpeakingGenericEditor from '../../sharedLogic/SpeakingGenericEditor';
import speakingConvertToUploadFormat from "@dyl/task-types/sharedLogic/speakingConvertToUploadFormat";
import {
    createSpeakingSimpleItem, createSpeakingHighlightItem, createSpeakingAdditionalImageItem
} from '../../sharedLogic/speakingItemCreators';

export default createSpeakingTaskType({
    id: 'meet_and_greet',
    label: 'Meet and Greet',
    skill: 'speaking',
    v2: true,
    hasRubric: false,

    editor: withProps(SpeakingGenericEditor, { disableTargets: true, includeContextAudioField: false }),
    createItemsTemplate: () => [
        createSpeakingSimpleItem(),
        createSpeakingHighlightItem(),
        createSpeakingAdditionalImageItem()
    ],

    hasEndAudio: true,
    backgroundImages: { count: 1 },

    convertToUploadFormat: speakingConvertToUploadFormat,
});